import React from "react";
import { Link } from "react-router-dom";

export const Footer = () => (
  <footer className="border-t border-race-line mt-16 py-8 px-4" data-testid="site-footer">
    <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
      <p className="text-xs text-race-muted">© {new Date().getFullYear()} Text Racing - sanctioned by IBRA. All rights reserved.</p>
      <nav className="flex items-center gap-4 text-xs">
        <Link to="/advertise" data-testid="footer-advertise" className="text-race-volt hover:opacity-80 transition-opacity font-semibold">Advertise on Text Racing</Link>
        <Link to="/terms" data-testid="footer-terms" className="text-race-sub hover:text-race-red transition-colors">Terms</Link>
        <Link to="/privacy" data-testid="footer-privacy" className="text-race-sub hover:text-race-red transition-colors">Privacy</Link>
        <Link to="/messaging-policy" data-testid="footer-messaging" className="text-race-sub hover:text-race-red transition-colors">Messaging Policy</Link>
      </nav>
    </div>
  </footer>
);

export default Footer;
